import React, { useEffect, useState } from "react";
import {
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
} from "@mui/material";
import { Link,useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import AirIcon from "@mui/icons-material/Air";
import StormIcon from "@mui/icons-material/Storm";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import SendIcon from "@mui/icons-material/Send";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { PieChart } from "@mui/icons-material";
import logoMain from "./../../assets/logoMain.png";
import useWebSocket from "react-use-websocket";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import BarChartIcon from "@mui/icons-material/BarChart";
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';

import axios from "axios";
import OperationsComponent from "../../container/login/operations/operations";
import { Button } from "@mui/material";

interface ChatMessage {
  id: number;
  file: string;
  user_type: string;
  imgfile: string;
  file_name: any;
  date_time: string;
  message: string;
  user: string;
}

interface CountRoom {
  unread_admin: number;
}

const SideNavMenu = (props: any) => {
  const location = useLocation();
  const [countAdmin, setcountAdmin] = useState(0);
  const [countUser, setcountUser] = useState(0);
  const [unreadMsgs, setUnreadMsgs] = useState<number>(0);
  const [messageCount, setmessageCount] = useState(0);
  const [socketOpened, setSocketOpened] = useState(false);
  //const [isSatactive, setIsSatactive] = useState(isPathActive "/satellite");
  const isAdmin = localStorage.getItem("type") === "admin";
  const [clients, setClients] = useState<any[]>([]);
  const [operationOpen, setOperationOpen] = useState(false);

  const socketUrl = `wss://${
    process.env.REACT_APP_WEBSOCKET_IP
  }/ws/chat/${localStorage.getItem("user_id")}/`;
  // console.log("socket URL",socketUrl);
  
  const {
    sendMessage,
    sendJsonMessage,
    lastMessage,
    lastJsonMessage,
    readyState,
    getWebSocket,
  } = useWebSocket(socketUrl, {
    onOpen: () => {
      //  console.log("URL opened");
      setSocketOpened(true);
      sendJsonMessage({
        mode: "sidebar",
        token: localStorage.getItem("token"),
        user_type: localStorage.getItem("type"),
        user_id: localStorage.getItem("user_id"),
      });
    },
    shouldReconnect: (closeEvent) => true,
    onMessage: (event) => processWebSocketMessages(event),
  });

  const getList = () => {
    sendJsonMessage({
      mode: "sidebar",
      token: localStorage.getItem("token"),
      user_type: localStorage.getItem("type"),
      user_id: localStorage.getItem("user_id"),
    });
  };

  const isPathActive = (path: string) => {
    return location.pathname === path;
  };

  const [isActive, setIsActive] = useState(isPathActive("/charts"));

  function processWebSocketMessages(event: any) {
    // console.log("process web secket")
    let data = JSON.parse(event.data);
    if (data.mode === "latest") {
      getList();
    }

    if (data.mode === "createchat") getList();

    if (data.user_type == "admin" && data.mode === "sidebar") {
      setcountAdmin(data.count);
    }
    if (data.user_type == "user" && data.mode === "sidebar") {
      if (window.location.href.split("/")[3] === "chat") {
        sendJsonMessage({
          mode: "userchat",
          user_id: localStorage.getItem("user_id"),
          user_type: localStorage.getItem("type"),
          chat_id: localStorage.getItem("rooms"),
        });
      }
      setcountUser(data.count);
    }
  }

  useEffect(() => {
    if (!sessionStorage.getItem("token") || !sessionStorage.getItem("auth_operation")) {
      window.location.href = "/auth";
    }
  }, []);
  if (isPathActive("/operations")) {
    return null;
  }

  const handleOpenOperations = () => {
    setOperationOpen(true);
  };

  const closeOperations = () => {
    setOperationOpen(false);
    window.location.href = "/dashboard";
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (isAdmin) {
      axios
        .get(`${process.env.REACT_APP_BACKEND_IP}/api/getclients/`)
        .then((response: any) => setClients(response.data))
        .catch((error: any) => console.error("Error fetching clients:", error));
    }
  }, [isAdmin]);

  return (
    <div className="sidenav">
      <img
        alt={"logo"}
        style={{ borderRadius: "10px", marginInline: "10px", marginTop: 40 }}
        src={logoMain}
      />

      {operationOpen && (
        <OperationsComponent
          isAdmin={isAdmin}
          open={operationOpen}
          close={closeOperations}
          showCancelButton={true} 
        />
      )}
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1em" }}
      >
        <Button
          variant="contained"
          onClick={handleOpenOperations}
          className="operations-button"
        >
          CHANGE LOCATION
        </Button>
      </div>
      <MenuList
        className="Nav-menu-LIst"
        style={{ gap: "10px", overflow: "auto" }}
      >
        <MenuItem className={isPathActive("/dashboard") ? "custom_active" : ""}>
          <Link
            to={"/dashboard"}
            state={{ title: "Dashboard" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <DashboardIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Dashboard</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/forecast") ? "custom_active" : ""}>
          <Link
            to={"/forecast"}
            state={{ title: "Forecast" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <CloudQueueIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Tabular Forecast</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/overview") ? "custom_active" : ""}>
          <Link
            to={"/overview"}
            state={{ title: "Quick Overview" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <QuickreplyIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Graphical Forecast</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/weather") ? "custom_active" : ""}>
          <Link
            to={"/weather"}
            state={{ title: "Weather Window" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <ArtTrackIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Weather Windows</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/charts") ? "custom_active" : ""}>
          <Link
            to={"/charts"}
            state={{ title: "charts" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <BarChartIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Charts</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/squall") ? "custom_active" : ""}>
          <Link
            to={"/squall"}
            state={{ title: "squall" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <AirIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Squall</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/typhoon") ? "custom_active" : ""}>
          <Link
            to={"/typhoon"}
            state={{ title: "typhoon" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <StormIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Tropical Cyclone</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem className={isPathActive("/satellite") ? "custom_active" : ""}>
          <Link
            to={"/satellite"}
            state={{ title: "satellite" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <SatelliteAltIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Satellite</ListItemText>
          </Link>
        </MenuItem>
        <MenuItem
          className={isPathActive("/observation") ? "custom_active" : ""}
        >
          <Link
            to={"/observation"}
            state={{ title: "Submit Observation" }}
            style={{ display: "flex" }}
          >
            <ListItemIcon>
              <SendIcon style={{ color: "white" }} fontSize="small" />
            </ListItemIcon>
            <ListItemText>Submit Observation</ListItemText>
          </Link>
        </MenuItem>
        {localStorage.getItem("type") === "user" ? (
          <MenuItem
            style={{
              backgroundColor: isPathActive("/chat") ? "#1976d2" : "inherit",
              color: isPathActive("/chat") ? "white" : "inherit",
              borderRadius: "5px",
            }}
          >
            <Link
              to={"/chat"}
              state={{ title: "Chat" }}
              style={{
                display: "flex",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <ListItemIcon>
                <ConnectWithoutContactIcon
                  style={{ color: "white" }}
                  fontSize="small"
                />
              </ListItemIcon>
              <Badge
                badgeContent={countUser}
                onClick={() => setcountUser(0)}
                color="info"
              >
                <ListItemText>Contact Duty Forecaster</ListItemText>
              </Badge>
            </Link>
          </MenuItem>
        ) : (
          <MenuItem
            style={{
              backgroundColor: isPathActive("/adminchat")
                ? "#1976d2"
                : "inherit",
              color: isPathActive("/adminchat") ? "white" : "inherit",
              borderRadius: "5px",
            }}
          >
            <Link
              to={"/adminchat"}
              state={{ title: "Chat" }}
              style={{
                display: "flex",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <ListItemIcon>
                <ConnectWithoutContactIcon
                  style={{ color: "white" }}
                  fontSize="small"
                />
              </ListItemIcon>
              <Badge badgeContent={countAdmin} color="info">
                <ListItemText>Contact Duty Forecaster</ListItemText>
              </Badge>
            </Link>
          </MenuItem>
        )}
        {localStorage.getItem("type") === "admin" ? (
          <MenuItem
            className={isPathActive("/usermanagement") ? "custom_active" : ""}
          >
            <Link
              to={"/usermanagement"}
              state={{ title: "Usermanagement" }}
              style={{ display: "flex", alignItems: "center" }}
            >
              <SupervisorAccountIcon style={{ marginRight: "8px" }}>
                <StormIcon style={{ color: "white" }} fontSize="small" />
              </SupervisorAccountIcon>
              <ListItemText>User Management</ListItemText>
            </Link>
          </MenuItem>
        ) : null}
      </MenuList>
    </div>
  );
};

export default SideNavMenu;
